import { yupResolver } from '@hookform/resolvers/yup'
import { Button, DSButtonType, Input, type OptionProps, Select } from 'components'
import { Controller, type SubmitHandler, useForm } from 'react-hook-form'
import { useSelector } from 'store/store'
import * as yup from 'yup'

import * as S from './styles'

export type CancelOvReason = {
  reasonsRefusal: string
  refusalDescription: string
}

const schema = yup.object().shape({
  reasonsRefusal: yup.string().required(),
  refusalDescription: yup.string().required(),
})

type CancelOvFormProps = {
  setOpen: (open: boolean) => void
  cancelAction: (data: CancelOvReason) => void
}

const CancelOvForm = ({ setOpen, cancelAction }: CancelOvFormProps) => {
  const { reasonsRefusal } = useSelector(({ ov }) => ov)

  const getRefusalOptions = (): OptionProps[] | undefined => {
    if (reasonsRefusal) {
      return reasonsRefusal.map((reason) => ({
        title: reason.DescricaoMotivo,
        value: reason.CodigoMotivoRecusa,
      }))
    }
    return
  }

  const defaultValues = {
    reasonsRefusal: '',
    refusalDescription: '',
  }

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<CancelOvReason>({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
    reValidateMode: 'onBlur',
  })

  const handleCancelSubmit: SubmitHandler<CancelOvReason> = (data) => {
    cancelAction(data)
  }

  return (
    <S.Form onSubmit={handleSubmit(handleCancelSubmit)}>
      <Controller
        control={control}
        name="reasonsRefusal"
        render={({ field: { name, value, onChange } }) => (
          <Select
            error={errors.reasonsRefusal}
            focused={false}
            id="reasonsForRefusal"
            label="Motivo"
            menuText="Selecione um motivo"
            name={name}
            onChange={onChange}
            options={getRefusalOptions()}
            optionsMaxHeight={'35vh'}
            required
            value={value}
          />
        )}
      />
      <Controller
        control={control}
        name="refusalDescription"
        render={({ field: { name, value, onChange } }) => (
          <S.InputWrapper>
            <Input
              height={90}
              id="DescriptionForRefusal"
              label="Descrição"
              maxLength={500}
              name={name}
              onChange={onChange}
              placeholder={'Descreva aqui o motivo do cancelamento.'}
              required
              rows={3}
              showMaxLength
              value={value}
            />
          </S.InputWrapper>
        )}
      />

      <S.FooterWrapper>
        <div>
          <Button
            color="secondary"
            content="Voltar"
            design={DSButtonType.ICON_BUTTON}
            onClick={() => setOpen(false)}
            type="button"
          />
        </div>
        <div>
          <Button
            color="primary"
            content="Cancelar"
            design={DSButtonType.PRIMARY_BUTTON}
            disabled={!isValid}
            type="submit"
          />
        </div>
      </S.FooterWrapper>
    </S.Form>
  )
}

export default CancelOvForm
